import { Component, AfterContentInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
  standalone: false
})
export class TermsAndConditionsComponent implements AfterContentInit {
  private translateService = inject(TranslateService);

  public currentLang: string;


  constructor() {
    const translateService = this.translateService;

    this.currentLang = translateService.currentLang;
  }

  ngAfterContentInit(): void {
    this.translateService.onLangChange.subscribe((x) => {
      this.currentLang = x.lang;
    });
  }
}
